
import ApiService from "@/core/services/api.service";


export const SET_LISTA_INGRESSO = "setListParceiros";
export const SET_LISTA_INGRESSO_REV = "setListParceirosRev";
export const SET_INGRESSO = "setParceiros";
export const SET_ROTA = "setRota"
export const SET_MESSAGE_ALERT = 'setMensagem'




const actions = {
    //evento
    async create_parceiro(context, value) {

        await ApiService.post('parceiro', value)
            .then(response => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'success',
                message: response.data
            }))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error',
                message: error.response.data
            }))
    },




    async update_parceiro(context, value) {

        await ApiService.put('parceiro/'+value.id,value)
            .then(response => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'success',
                message: response.data
            }))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error',
                message: error.response.data
            }))
    },

    async listar_parceiros(context) {
        await ApiService.get('parceiro')
            .then(response => {
                context.commit(SET_LISTA_INGRESSO, response.data)
            })
            .catch((error) => {
                context.commit(SET_MESSAGE_ALERT, {
                    tipo: 'error',
                    message: error.response.data
                })
            })
    },

    async bloquear_parceiro(context, value) {


        await ApiService.delete("parceiro/" + value.id)
          .then((response) =>
            context.commit(SET_MESSAGE_ALERT, {
              tipo: "success",
              message: response.data,
            })
          )
          .catch((error) =>
            context.commit(SET_MESSAGE_ALERT, {
              tipo: "error",
              message: error.response.data,
            })
          );
    
    
   
        context.commit(SET_LISTA_INGRESSO_REV, value)
    
    
      },

      set_rota(context, value) {
        context.commit(SET_ROTA,value)
      }



};
const getters = {};

const mutations = {
    [SET_LISTA_INGRESSO](state, value) {
        state.lista_parceiros = value;
    },
    [SET_LISTA_INGRESSO_REV](state, value) {
        state.lista_parceiros = state.lista_parceiros.filter(
            (parceiro) => parceiro.id !== value.id
        );
    },
    [SET_INGRESSO](state, value) {
        state.evento = value;
    },
    [SET_ROTA](state,value){
        state.rota = value
    },
    [SET_MESSAGE_ALERT](state, value) {
      
        let customMessage;
        if (typeof value.message === "object") {
    
          customMessage = value.message.msg;
        }
        state.mensagem_alert = {
          tipo: value.tipo,
          message: customMessage ? customMessage : value.msg,
        };
      },

};

const state = {
    lista_parceiros: [],
    lista_parceiros_Evento: [],
    evento:{},
    mensagem_alert: "",
    rota:"",

};

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state,
};
